export default "__VITE_ASSET__B1g7s3pQ__"